import axios from '@/config/axios';
import Router from '@/router/index'
// import axios from 'axios';
// initial state
const initialState = () => {
    return {
        user: null,
        authenticationDetails: {},
        signupStatus: null,
        verifyStatus: {},
        verificationEmailSent: {},
        errorMessage: null,
        resendOtpStatus: false,
        authenticationStatus: false,
        otpStatus: [],
        // validationErrors: [],
        resetStatus: {},
        passwordUpdateStatus: {}
    };
};
const state = initialState();
const getters = {
    getAuthenticatedUser: state => state.user,
    // getValidationErrors: state => state.validationErrors,
    getVerificationEmailSentStatus: state => state.verificationEmailSent,
    getVerifyStatus: state => state.verifyStatus,
    getResendOtpStatus: state => state.resendOtpStatus,
    getSignupStatus: state => state.signupStatus,
    getAuthenticationStatus: state => state.authenticationStatus,
    getAuthenticationDetails: state => state.authenticationDetails,
    getErrorMessage: state => state.errorMessage,
    getOtpStatus: state => state.otpStatus,
    getResetStatus: state => state.resetStatus,
    getPasswordUpdateStatus: state => state.passwordUpdateStatus
};

const mutations = {
    setSignupStatus: (state, status) => {
        state.signupStatus = status;
    },
    setVerifyStatus: (state, statusData) => {
        state.verifyStatus = statusData;
    },
    setResendOtp: (state, statusData) => {
        state.verificationEmailSent = statusData;
    },
    setAuthenticatedUser: (state, user) => {
        state.user = user;
    },
    setAuthenticationStatus: (state, status) => {
        state.authenticationStatus = status;
    },
    setAuthenticationDetails: (state, tokens) => {
        state.authenticationDetails = tokens;
    },
    setErrorMessage: (state, message) => {
        state.errorMessage = message;
    },
    setResendOtpStatus: (state, status) => {
        state.resendOtpStatus = status;
    },
    setOtpStatus: (state, statusData) => {
        state.otpStatus = statusData;
    },
    setResetStatus: (state, statusData) => {
        state.resetStatus = statusData;
    },
    setPasswordUpdateStatus: (state, statusData) => {
        state.passwordUpdateStatus = statusData;
    },
    resetAuthData: state => {
        const initial = initialState();
        Object.keys(initial).forEach(key => {
            state[key] = initial[key];
        });
    }
};
const actions = {
    // user sign up
    signup: async(context, params) => {

        context.commit('auth/resetAuthData', null, { root: true });
        await context.dispatch('errors/clear', null, {root: true});

        try {
            const response = await axios.post('/auth/register', params);
            context.commit('errors/setMessage', response.data.message, { root: true });
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    // verify user account 
    verifyAccount: async(context, params) => {
        await context.dispatch('errors/clear', null, {root: true});

        try {
            let response = await axios.post('/auth/verify-user', params);
            context.commit('errors/clear', null, { root: true });
            context.commit('auth/setVerificationStatus', [], { root: true });
            context.commit('errors/setMessage', response.data.message, { root: true });
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, { root: true });
        }

    },
    resendOTP: async(context, params) => {
        try {
            let response = await axios.post('/auth/send-otp', params);

            context.commit('errors/setMessage', response.data.message, {
                root: true
            });
        } catch (error) {
            if (error.response) {
                context.commit('errors/setMessage', error.response.data.message, {
                    root: true
                });
            }
        }
    },
    async sign_in(context, params) {
        context.commit('auth/resetAuthData', null, { root: true });
        await context.dispatch('errors/clear', null, {root: true});
        try {
            let response = await axios.post('/auth/login', params);

            let userDetails = response.data.user;
            let tokens = {
                access_token: response.data.access_token,
                refresh_token: response.data.refresh_token
            };
            context.commit('auth/setErrorMessage', null, { root: true });
            context.commit('auth/setAuthenticatedUser', userDetails, { root: true });
            context.commit('auth/setAuthenticationStatus', true, { root: true });
            context.commit('auth/setAuthenticationDetails', tokens, { root: true });
            context.commit('errors/setMessage', response.data.message, { root: true });

        } catch (error) {

            context.commit('auth/setAuthenticatedUser', null, { root: true });

            context.commit('auth/setAuthenticationStatus', false, { root: true });

            await context.dispatch('errors/errorResponse', error.response, {root: true});
            if (error.response.status === 403) {
                context.commit('auth/setResendOtpStatus', true, { root: true });
            }
            if (error.response.status === 406) {
                context.commit('errors/setMessage', error.response.data.data.error, { root: true });
                await context.dispatch('auth/resendOTP', {
                    username: params.username
                }, { root: true })
                Router.push({ name: 'verify-account', query: { email: params.username } });
            }
        }
    },
    forgotPassword: async(context, params) => {
        await context.dispatch('errors/clear', null, {root: true});
        context.commit('auth/resetAuthData', null, { root: true });
        context.commit('auth/setOtpStatus', [], {
            root: true
        });
        await context.dispatch('errors/clear', null, {root: true});
        try {
            let response = await axios.post('/auth/send-otp', params);
            context.commit('auth/setOtpStatus', response.data, {
                root: true
            });
        } catch (error) {
            await context.dispatch('errors/errorResponse', error.response, {root: true});
        }
    },
    resetPassword: async(context, params) => {
        await context.dispatch('errors/clear', null, {root: true});
        context.commit('auth/resetAuthData', null, { root: true });
        context.commit('auth/setErrorMessage', null, {
            root: true
        });
        context.commit('auth/setResetStatus', null, {
            root: true
        });
        try {
            let response = await axios.post('/auth/reset-password', params);
            context.commit('auth/setResetStatus', response.data, {
                root: true
            });
        } catch (error) {
            if (error.response) {
                context.dispatch('errors/errorResponse', error.response, { root: true });
            } else {
                context.commit('auth/setErrorMessage', error.response.data, {
                    root: true
                });
            }
        }
    },
    // sign out
    async sign_out(context) {
        try {
            const response = await axios.post('/auth/logout');
            context.commit('auth/resetAuthData', null, { root: true });
            context.commit('auth/setAuthenticationStatus', false, { root: true });
            context.commit('errors/setMessage', response.data.message, { root: true });

        } catch (error) {
            context.commit('auth/resetAuthData', null, { root: true });
            context.dispatch('errors/errorResponse', error.response, { root: true });

        }
    },
    reset: context => {
        context.commit('auth/resetAuthData', null, { root: true });
    },
    refresh: async context => {
        context.commit('auth/resetAuthData', null, { root: true });
        this.$router.push({ name: 'sign_in' });
    }
};
export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
